import { TOKENS_PER_PAGE } from "config"
import { OrderDirection, Token } from "utils/types"
import Loading from "components/Loading"
import MetadataAwareTokenView from "components/MetadataAwareTokenView"
import useTokens from "hooks/useTokens"
import useWindowSize from "hooks/useWindowSize"

interface Props {
  contractAddress: string
  projectId: string
  first?: number
  skip?: number
  orderDirection?: OrderDirection
  aspectRatio?: number
  chainId?: number
}

const Tokens = ({
  contractAddress,
  projectId,
  first = TOKENS_PER_PAGE,
  skip = 0,
  orderDirection = OrderDirection.ASC,
  aspectRatio = 1,
  chainId,
}: Props) => {
  const windowSize = useWindowSize()
  const { loading, error, data } = useTokens(projectId, { first, skip, orderDirection })

  const colWidth =
    windowSize.width >= 1200
      ? (1200 - 96) / 3
      : windowSize.width >= 768
      ? (windowSize.width - 96) / 3
      : (windowSize.width - 60) / 2

  if (loading) return <Loading />
  if (error) return <p className="text-sm text-red-500">Error loading tokens.</p>
  if (!data?.tokens?.length) return <p className="text-sm text-gallery-muted">No tokens yet.</p>

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
      {data.tokens.map((token: Token) => (
        <a key={token.tokenId} href={`/token/${contractAddress}/${token.tokenId}`} className="block group">
          <div className="overflow-hidden group-hover:opacity-90 transition-opacity duration-300">
            <MetadataAwareTokenView
              contractAddress={contractAddress}
              tokenId={token.tokenId}
              chainId={chainId}
              fallbackAspectRatio={aspectRatio}
              width={Math.floor(colWidth)}
            />
          </div>
          <p className="mt-2 gallery-label text-gallery-muted">#{token.invocation.toString()}</p>
        </a>
      ))}
    </div>
  )
}

export default Tokens
